const checkTermMatchesSkusRefOrEan = (firstResult: Product, term: string) => {
  return firstResult.skus.some((sku) => {
    const skuMatches = [sku.refId, sku.ean]

    return skuMatches.some((skuMatch) => skuMatch === term)
  })
}

export const checkShouldRedirectToProductPage = (
  searchResults: Product[],
  term: string
): boolean => {
  const [firstResult] = searchResults

  return (
    (!!firstResult && firstResult.id === term) ||
    checkTermMatchesSkusRefOrEan(firstResult, term)
  )
}
